import { Component } from '@angular/core';
import { RickService } from '../service/rick.service';
import { FormBuilder, FormGroup, Validators, FormArray, ReactiveFormsModule, FormsModule, AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { TableComponent } from '../common/table/table.component';
import { CommonModule } from '@angular/common';
import { Router, ActivatedRoute, RouterOutlet } from '@angular/router';
import { DataSharingService } from '../service/data-sharing.service';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [TableComponent, CommonModule, RouterOutlet, FormsModule, ReactiveFormsModule],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
  providers: [RickService]
})
export class DashboardComponent {
  rickCustomerData!: any[];
  maintenanceSearchForm: FormGroup = new FormGroup({});
  columns = [
    {
      field: '',
      header: 'Revise',
      isFrozenColumn: true,
      showEditIcon: true,
      sortable: false
    },
    {
      field: '',
      header: 'View',
      isFrozenColumn: true,
      showViewIcon: true,
      sortable: false
    },
    {
      field: '',
      header: 'Copy',
      isFrozenColumn: true,
      showCopyIcon: true,
      sortable: false
    },
    {
      field: 'customer',
      header: 'Customer',
      sortable: false
    },
    {
      field: 'startDate',
      header: 'Start Date',
      sortable: false
    },
    {
      field: 'endDate',
      header: 'End Date',
      sortable: false
    },
    {
      field: 'state',
      header: 'State',
      sortable: false
    },
    {
      field: 'store',
      header: 'Store',
      sortable: false
    },
    {
      field: 'lot',
      header: 'Lot'
    },
    {
      field: 'consignmentType',
      header: 'Consign Type',
      sortable: false
    }
  ];
  options = {
    first: 0,
    rows: 0,
    pagination: false,
    totalRecords: '0'
  };
  rows = 10;
  offset = 0;
  searchText = '';
  dataLoaded = true;
  sortOrder = 1;
  sortColumn = '';
  customer: any = '';
  state: any = '';
  store: any = '';
  lot: any = '';
  submitted: boolean = false;

  constructor(private fb: FormBuilder, private rickService: RickService, private router: Router,
    private route: ActivatedRoute, private dataSharingService: DataSharingService
  ) { }

  ngOnInit() {
    this.maintenanceSearchForm = this.fb.group({
      customer: ['', Validators.required],
      state: ['', Validators.required],
      store: ['', Validators.required],
      lot: ['', Validators.required]
    });
  }

  editData(data: any) {
    this.dataSharingService.changeData(data);
    this.router.navigate(['/model-maintenance']);
  }

  copyData(data: any) {
    this.dataSharingService.changeData(data);
    this.router.navigate(['/copy']);
  }

  viewData(data: any) {
    this.dataSharingService.changeData(data);
    this.router.navigate(['/view']);
  }

  addData() {
    this.dataSharingService.changeData({});
    this.router.navigate(['/model-maintenance']);
  }

  setupTableData(data: any) {
    data.customer = data.modelsIdDto?.edpNumberDto.customer;
    data.state = data.modelsIdDto?.edpNumberDto.state;
    data.store = data.modelsIdDto?.edpNumberDto.store;
    data.lot = data.modelsIdDto.lot;
    this.options['rows'] = this.rows;
    this.options['totalRecords'] = '1'; //data.totalRecords;
    this.options['first'] = this.offset;
    this.rickCustomerData = [data];
    this.dataLoaded = true;
  }

  searchData(data: any) {
    this.searchText = data;
    this.searchmodeldata();
  }

  searchClear() {
    this.searchText = '';
  }

  searchmodeldata() {
    this.submitted = true;
    if (this.maintenanceSearchForm.valid) {
      this.customer = this.maintenanceSearchForm.controls.customer.value;
      this.state = this.maintenanceSearchForm.controls.state.value;
      this.store = this.maintenanceSearchForm.controls.store.value;
      this.lot = this.maintenanceSearchForm.controls.lot.value;
      this.rickService.getCustomerById(this.customer, this.state, this.store, this.lot).subscribe((res) => {
        console.log('res', res);
        this.setupTableData(res);
      }, (error) => {
        console.log('error', error.error)
        this.maintenanceSearchForm?.setErrors({ invalid: error?.error?.errorMessages[0] });
      });
    }
  }

  cancelPage() {
    this.router.navigate(['/home']);
  }

}
